import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const RealTimeClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();

  const formatTime = (num) => String(num).padStart(2, '0');

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const dayName = days[time.getDay()];
  const monthName = months[time.getMonth()];
  const date = time.getDate();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          background: 'linear-gradient(135deg, rgba(0,0,0,0.3), rgba(15,39,68,0.4))',
          backdropFilter: 'blur(10px)',
          borderRadius: 3,
          p: 1,
          px: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.2), inset 0 1px 0 rgba(212,175,55,0.15)',
          border: '1px solid rgba(212, 175, 55, 0.15)',
          minWidth: 130,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.03), transparent)',
            animation: 'shimmer 3s ease-in-out infinite',
          },
        }}
      >
        {/* Date Section */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          pr: 1.5, 
          borderRight: '1px solid rgba(212, 175, 55, 0.2)',
        }}>
          <Typography
            sx={{
              fontSize: '0.6rem',
              fontWeight: 700,
              color: '#D4AF37',
              letterSpacing: '1.5px',
              lineHeight: 1.2,
            }}
          >
            {dayName}
          </Typography>
          <motion.div
            key={date}
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 800,
                color: '#FFFFFF',
                lineHeight: 1.1,
              }}
            >
              {date}
            </Typography>
          </motion.div>
          <Typography
            sx={{
              fontSize: '0.55rem',
              fontWeight: 600,
              color: '#8AA87D',
              letterSpacing: '0.5px',
            }}
          >
            {monthName}
          </Typography>
        </Box>

        {/* Time Section */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography
            sx={{
              fontFamily: '"JetBrains Mono", "Fira Code", "Roboto Mono", monospace',
              fontSize: '1.25rem',
              fontWeight: 700,
              color: '#D4AF37',
              letterSpacing: 2,
              lineHeight: 1,
              textShadow: '0 0 10px rgba(212,175,55,0.2)',
            }}
          >
            {formatTime(hours)}:{formatTime(minutes)}
          </Typography>
          <motion.div
            animate={{ opacity: [0.3, 1, 0.3] }}
            transition={{ duration: 1, repeat: Infinity }}
          >
            <Typography
              sx={{
                fontFamily: '"JetBrains Mono", "Fira Code", "Roboto Mono", monospace',
                fontSize: '0.7rem',
                fontWeight: 600,
                color: '#8AA87D',
                letterSpacing: 1.5,
              }}
            >
              :{formatTime(seconds)}
            </Typography>
          </motion.div>
        </Box>
      </Box>
    </motion.div>
  );
};

export default RealTimeClock;